var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.5833 67.8333C100.692 67.8333 104.833 63.692 104.833 58.5833C104.833 53.4747 100.692 49.3333 95.5833 49.3333C90.4746 49.3333 86.3333 53.4747 86.3333 58.5833C86.3333 63.692 90.4746 67.8333 95.5833 67.8333Z",
    fill: "#C1C1C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4167 67.8333C57.5254 67.8333 61.6667 63.692 61.6667 58.5833C61.6667 53.4747 57.5254 49.3333 52.4167 49.3333C47.3081 49.3333 43.1667 53.4747 43.1667 58.5833C43.1667 63.692 47.3081 67.8333 52.4167 67.8333Z",
    fill: "#C1C1C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9382 12.3333C39.8983 12.3333 12.3333 39.96 12.3333 74C12.3333 108.04 39.8983 135.667 73.9382 135.667C108.04 135.667 135.667 108.04 135.667 74C135.667 39.96 108.04 12.3333 73.9382 12.3333ZM73.9999 123.333C46.7433 123.333 24.6666 101.257 24.6666 74C24.6666 46.7433 46.7433 24.6667 73.9999 24.6667C101.257 24.6667 123.333 46.7433 123.333 74C123.333 101.257 101.257 123.333 73.9999 123.333ZM73.9999 86.3333C59.6316 86.3333 47.3599 95.275 42.4266 107.917H52.7249C56.9799 100.578 64.8732 95.5833 73.9999 95.5833C83.1266 95.5833 90.9583 100.578 95.2749 107.917H105.573C100.64 95.275 88.3682 86.3333 73.9999 86.3333Z",
    fill: "#C1C1C1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/defaultIcon.a21ba10b.svg";
export { ForwardRef as ReactComponent };